import { render, staticRenderFns } from "./AuthSuccess.vue?vue&type=template&id=46d276f0&scoped=true&"
import script from "./AuthSuccess.vue?vue&type=script&lang=ts&"
export * from "./AuthSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./AuthSuccess.vue?vue&type=style&index=0&id=46d276f0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d276f0",
  null
  
)

export default component.exports